import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import {
  CreateNpsEvaluator,
  UpdateNpsEvaluator,
  FiltersNpsEvaluators
} from '@/Network/Types/Requests/NpsRequests'
import {
  NpsEvaluatorResponse,
  ListNpsEvaluatorsResponse
} from '@/Network/Types/Responses/NpsResponses'

export default class NpsEvaluatorService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/nps/evaluators'
  }

  async create(payload: CreateNpsEvaluator): Promise<NpsEvaluatorResponse> {
    try {
      const response = await request.post<NpsEvaluatorResponse>(this.getCompletePath(), payload)
      return response.data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível criar o avaliador.')
    }
  }

  async update(evaluatorId: number, payload: UpdateNpsEvaluator): Promise<NpsEvaluatorResponse> {
    try {
      const response = await request.put<NpsEvaluatorResponse>(
        `${this.getCompletePath()}/${evaluatorId}`,
        payload
      )
      return response.data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível atualizar o avaliador.')
    }
  }

  async toggleActive(evaluatorId: number, companyId: number): Promise<NpsEvaluatorResponse> {
    try {
      const response = await request.patch(
        `${this.getCompletePath()}/${evaluatorId}/toggle-active?companyId=${companyId}`,
        {}
      )

      return response.data as NpsEvaluatorResponse
    } catch (e) {
      throw this.handleError(e, 'Não foi possível alterar o status do avaliador.')
    }
  }

  async getById(evaluatorId: number): Promise<NpsEvaluatorResponse> {
    try {
      const response = await request.get<NpsEvaluatorResponse>(
        `${this.getCompletePath()}/${evaluatorId}`
      )
      return response.data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar o avaliador.')
    }
  }

  async delete(evaluatorId: number): Promise<void> {
    try {
      await request.delete(`${this.getCompletePath()}/${evaluatorId}`)
    } catch (e) {
      throw this.handleError(e, 'Não foi possível excluir o avaliador.')
    }
  }

  async list(filters?: FiltersNpsEvaluators): Promise<ListNpsEvaluatorsResponse> {
    try {
      const { data } = await request.get<ListNpsEvaluatorsResponse>(this.getCompletePath(), filters)
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar os avaliadores.')
    }
  }
}
